import _regeneratorRuntime from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _createClass from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { atr } from "../directionalmovement/ATR";
import { CandleList } from "../StockData";
/**
 * Created by AAravindan on 5/4/16.
 */

import { Indicator, IndicatorInput } from "../indicator/indicator";
export var RenkoInput =
/*#__PURE__*/
function (_IndicatorInput) {
  _inherits(RenkoInput, _IndicatorInput);

  function RenkoInput() {
    _classCallCheck(this, RenkoInput);

    return _possibleConstructorReturn(this, _getPrototypeOf(RenkoInput).apply(this, arguments));
  }

  return RenkoInput;
}(IndicatorInput);

var Renko =
/*#__PURE__*/
function (_Indicator) {
  _inherits(Renko, _Indicator);

  function Renko(input) {
    var _this;

    _classCallCheck(this, Renko);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Renko).call(this, input));
    var format = _this.format;
    var useATR = input.useATR;
    var brickSize = input.brickSize || 0;

    if (useATR) {
      var atrResult = atr(Object.assign({}, input));
      brickSize = atrResult[atrResult.length - 1];
    }

    _this.result = new CandleList();

    if (brickSize === 0) {
      console.error("Not enough data to calculate brickSize for renko when using ATR");
      return _possibleConstructorReturn(_this);
    }

    var lastOpen = 0;
    var lastHigh = 0;
    var lastLow = Infinity;
    var lastClose = 0;
    var lastVolume = 0;
    var lastTimestamp = 0;
    _this.generator =
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var candleData, absoluteMovementFromClose, absoluteMovementFromOpen, reference, calculated;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return;

            case 2:
              candleData = _context.sent;

            case 3:
              if (!true) {
                _context.next = 39;
                break;
              }

              if (!(lastOpen === 0)) {
                _context.next = 15;
                break;
              }

              lastOpen = candleData.close;
              lastHigh = candleData.high;
              lastLow = candleData.low;
              lastClose = candleData.close;
              lastVolume = candleData.volume;
              lastTimestamp = candleData.timestamp;
              _context.next = 13;
              return;

            case 13:
              candleData = _context.sent;
              return _context.abrupt("continue", 3);

            case 15:
              absoluteMovementFromClose = Math.abs(candleData.close - lastClose);
              absoluteMovementFromOpen = Math.abs(candleData.close - lastOpen);

              if (!(absoluteMovementFromClose >= brickSize && absoluteMovementFromOpen >= brickSize)) {
                _context.next = 30;
                break;
              }

              reference = absoluteMovementFromClose > absoluteMovementFromOpen ? lastOpen : lastClose;
              calculated = {
                open: reference,
                high: lastHigh > candleData.high ? lastHigh : candleData.high,
                low: lastLow < candleData.Low ? lastLow : candleData.low,
                close: reference > candleData.close ? reference - brickSize : reference + brickSize,
                volume: lastVolume + candleData.volume,
                timestamp: candleData.timestamp
              };
              lastOpen = calculated.open;
              lastHigh = calculated.close;
              lastLow = calculated.close;
              lastClose = calculated.close;
              lastVolume = 0;
              _context.next = 27;
              return calculated;

            case 27:
              candleData = _context.sent;
              _context.next = 37;
              break;

            case 30:
              lastHigh = lastHigh > candleData.high ? lastHigh : candleData.high;
              lastLow = lastLow < candleData.Low ? lastLow : candleData.low;
              lastVolume = lastVolume + candleData.volume;
              lastTimestamp = candleData.timestamp;
              _context.next = 36;
              return;

            case 36:
              candleData = _context.sent;

            case 37:
              _context.next = 3;
              break;

            case 39:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })();

    _this.generator.next();

    input.low.forEach(function (tick, index) {
      var result = _this.generator.next({
        open: input.open[index],
        high: input.high[index],
        low: input.low[index],
        close: input.close[index],
        volume: input.volume[index],
        timestamp: input.timestamp[index]
      });

      if (result.value) {
        _this.result.open.push(result.value.open);

        _this.result.high.push(result.value.high);

        _this.result.low.push(result.value.low);

        _this.result.close.push(result.value.close);

        _this.result.volume.push(result.value.volume);

        _this.result.timestamp.push(result.value.timestamp);
      }
    });
    return _this;
  }

  _createClass(Renko, [{
    key: "nextValue",
    value: function nextValue(price) {
      console.error("Cannot calculate next value on Renko, Every value has to be recomputed for every change, use calcualte method");
      return null;
    }
  }]);

  return Renko;
}(Indicator);

Renko.calculate = renko;
export function renko(input) {
  Indicator.reverseInputs(input);
  var result = new Renko(input).result;

  if (input.reversedInput) {
    result.open.reverse();
    result.high.reverse();
    result.low.reverse();
    result.close.reverse();
    result.volume.reverse();
    result.timestamp.reverse();
  }

  Indicator.reverseInputs(input);
  return result;
}